import { ItemKind } from '../../../constants/ItemKind';
export const toFolder = data => ({
  id: data.path_lower,
  name: data.name,
  kind: ItemKind.Folder,
  source: 'dropbox',
  parentId: data.path_lower && data.path_lower.split('/').slice(0, -1).join('/') || null,
  filesCount: 1,
  createdAt: null
});